var _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutostart = function SvgAutostart(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3585",
    width: 44,
    height: 44,
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -1008.4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4207",
    fill: "currentColor",
    transform: "translate(-174.52 910.99)scale(.98045)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3897",
    transform: "translate(-.005 79.903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3899",
    d: "M187.09 45.476a2.524 2.524 0 1 1-5.048 0 2.524 2.524 0 0 1 5.048 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3901",
    d: "M205.82 45.476a2.524 2.524 0 1 1-5.048 0 2.524 2.524 0 0 1 5.048 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3903",
    d: "M197.78 35.062a36 36 0 0 0-1.781.031c-.732.03-1.36.072-1.813.156-.345.123-4.969 3.375-4.969 3.375s-8.344 1.178-10.594 2.532l.22 2.28h-.626c-.446.145-.09.694.125 1.157h.719l.813.75v.344l1.156.031s.229-3.5 3.53-3.5c3.303 0 3.313 4 3.313 4h11.97s-.162-4.031 3.437-4.031 3.406 4.094 3.406 4.094c.989 0 1.604-.406 1.875-.875l.031-.594h.594c.2-.515.476-.985.156-1.344h-.468V40.25c-.53-.63-4.299-3.925-5.907-4.75-1.266-.272-3.314-.42-5.187-.437zm-2.312 1.281a.5.5 0 0 1 .156 0h2.125l-.531 3.156h-4.657c-.416-.008-.62-.663-.281-.906l3.063-2.156a.5.5 0 0 1 .125-.094m3.562 0h2.313a.5.5 0 0 1 .312.094l2.625 2.187c.298.263.085.861-.312.875h-5.438z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path3905",
    d: "M218.78 117.81a1 1 0 0 0-.062.031c-1.694.096-3.017 1.399-3.22 3.063-.177-.037-.342-.094-.53-.094-.98 0-1.729.582-2.22 1.344-.314-.2-.608-.425-1.03-.406-.431.019-.803.144-1.063.343s-.437.43-.688.657a.5.5 0 1 0 .688.718c.297-.27.455-.456.594-.562s.23-.144.5-.156c.287-.013.55.112.781.343a.5.5 0 0 0 .812-.156c.271-.663.876-1.125 1.625-1.125H215l1.75-1.75c.21-.359.519-.66.875-.875l1.343-1.375h-.062a.5.5 0 0 0-.094 0zm2.969 1.5-.719.719c.225.375.375.81.375 1.281 0 1.385-1.115 2.5-2.5 2.5-.485 0-.905-.141-1.281-.375l-1.188 1.187c-.013.02-.017.044-.03.063a1.7 1.7 0 0 1-.47.437l-1.25 1.25c.094.011.184.032.282.032 1.243 0 2.175-.9 2.53-2.032.445.205.887.438 1.407.438 1.926 0 3.5-1.574 3.5-3.5a3.4 3.4 0 0 0-.656-2m-11.688 4.781a.5.5 0 0 0-.281.844c.282.397.512.69.843.875.087.048.19.061.282.094l.843-.844c-.337-.007-.498-.055-.625-.125s-.282-.213-.53-.563a.5.5 0 0 0-.532-.28",
    color: "currentColor",
    style: {
      blockProgression: "tb",
      textIndent: 0,
      textTransform: "none"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect3912",
    width: 17,
    height: 1,
    x: 58.209,
    y: 239.17,
    ry: 0.319,
    transform: "rotate(-45)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutostart);
export default ForwardRef;